function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCatalogInactive = function SvgCatalogInactive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 37,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M24.5 13.5a4 4 0 014-4h6v15h-7a3 3 0 00-3 3v-14zm0 0a4 4 0 00-4-4h-6v15h7a3 3 0 013 3v-14zm0 0v14-14z",
    fill: "none",
    stroke: props.fill,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};
export default SvgCatalogInactive;